






















































import Button from '@/components/common/button.vue';
import { getPromiseHandler } from '@tencent/wphk-base-utils';
import { ScreenDialog } from '@tencent/wphk-ui';
import { computed, defineComponent, ref } from '@vue/composition-api';
import { language } from '@tencent/ppd-base-libs';
import { i18n } from '@/i18n';

// 兑换成功弹窗
export default defineComponent({
  name: 'ExchangeSuccDialog',
  components: {
    ScreenDialog,
    Button,
  },
  props: {
    btnConfigs: {
      type: Array,
      isRequired: true,
    },
    biExt: {
      type: Object,
      isRequired: true,
    },
    succDesc: {
      type: String,
      isRequired: false,
    },
    isShowCloseBtn: {
      type: Boolean,
      isRequired: false,
    },
  },
  setup(prop, context) {
    const exchangeSuccDialog = ref<ScreenDialog | null>(null);
    // 弹窗句柄，用于阻塞外部调用的流程
    const dialogHandler = ref();
    // 展示弹窗
    const showDialog = async () => {
      exchangeSuccDialog.value!.show();
      dialogHandler.value = getPromiseHandler();
      return dialogHandler.value.promise;
    };
    // 隐藏弹窗
    const hideDialog = () => {
      exchangeSuccDialog.value!.hide();
      dialogHandler.value.resolve('hideDialog');
    };
    const slots = computed(() => Object.keys(context.slots));

    const isEn = language.isEn();

    return {
      exchangeSuccDialog,
      showDialog,
      hideDialog,
      slots,
      isEn,
      i18n,
    };
  },
});

